const attendant = {
    attendantKlasikal: {
        icon: 'check-square',
        text: 'Klasikal',
        route: 'master',
        role: {
            classical: [ 'attendant' ],
        },
        children: {
            downloadMateri: {
                icon: null,
                text: 'Download Materi',
                route: 'admin.classical.attendant.resume.download',
                role: {
                    classical: [ 'attendant' ],
                },
            },
            uploadResume: {
                icon: null,
                text: 'Upload Resume',
                route: 'admin.classical.attendant.resume.upload',
                role: {
                    classical: [ 'attendant' ],
                },
            },
            ujianKlasikal: {
                icon: null,
                text: 'Ujian Klasikal',
                route: 'admin.classical.attendant.exam.session',
                role: {
                    classical: [ 'attendant' ],
                },
            },
            evaluasiPelaksanaan: {
                icon: null,
                text: 'Evaluasi Pelaksanaan',
                route: 'admin.classical.attendant.evaluation',
                role: {
                    classical: [ 'attendant' ],
                },
            },
        }
    },
    attendantRecap: {
        icon: 'file-done',
        text: 'Rekap Nilai',
        route: 'admin.classical.attendant.recap.score',
        role: {
            classical: [ 'attendant' ],
        }
    },
}

export default attendant
